import { RouteDictionary } from '@deltek/specification-client/core/Models/routeTypes'
import CompanyPage from 'pages/ProductsPage/CompanyPage'
import CompetitiveAnalysisPage from 'pages/ProductsPage/CompetitiveAnalysisPage'
import ProductDetailsPage from 'pages/ProductsPage/ProductDetailsPage'
import ProductListingsPage from 'pages/ProductsPage/ProductListingsPage'
import SubmissionPage from 'pages/ProductsPage/SubmissionPage'

export const ProductsPageRoutes: RouteDictionary = {
    '/': {
        redirect:
            '/all?groupby=sectionNumber%2520false%252CproductType%2520false&sortby=sectionNumber%252CproductType%252Ctype%252ClastUpdated%2520desc&ia=true&defaultFilter=true',
    },
    '/company/:firmId?': {
        name: 'Company',
        component: CompanyPage,
    },
    '/all': {
        name: 'Product Listings',
        component: ProductListingsPage,
    },
    '/competitive_analysis': {
        name: 'Competitive Analysis',
        component: CompetitiveAnalysisPage,
    },
    '/submissions': {
        name: 'Submissions',
        component: SubmissionPage,
    },
    '/product/listing/:listingId': {
        name: 'Product Details',
        component: ProductDetailsPage,
    },
}
